
export class BroadcastEvent {
    static onPageVisibilityShow = "onPageVisibilityShow";
    static onPageVisibilityHide = "onPageVisibilityHide";

    static updateAccountImage = "updateAccountImage";
    static groupFilterChanged = "groupFilterChanged";
    static hidePopup = "hidePopup";
    static onShowResourceFilterBar = "onShowResourceFilterBar";
    static onHideResourceFilterBar = "onHideResourceFilterBar";

    static closeResourceFilterBar = "closeResourceFilterBar";

    static updateVideoSize = "updateVideoSize";

    static openGeofenceEditor = "openGeofenceEditor";

    static onReportRun = "onReportRun";

    static UpdateBreadcrumbs = "updateBreadcrumbs";
}
